const StatisticsParkingList = r => require.ensure([], () => r(require('@/page/StatisticsParking/StatisticsParkingList')), 'StatisticsParkingList');
const StatisticsParkingView = r => require.ensure([], () => r(require('@/page/StatisticsParking/StatisticsParkingView')), 'StatisticsParkingView');
const PropertyParking = r => require.ensure([], () => r(require('@/page/StatisticsParking/StatisticsParkingTable/PropertyParking')), 'PropertyParking');
const DisputesParking = r => require.ensure([], () => r(require('@/page/StatisticsParking/StatisticsParkingTable/DisputesParking')), 'DisputesParking');
const chargingStatistics = r => require.ensure([], () => r(require('@/page/StatisticsParking/StatisticsParkingTable/chargingStatistics')), 'chargingStatistics');
const electricBicycleDetails = r => require.ensure([], () => r(require('@/page/StatisticsParking/StatisticsParkingTable/electricBicycleDetails')), 'electricBicycleDetails');

const StatisticsParkingRouter = {
    path: '',
    name: '停车位统计',
    component: StatisticsParkingView,
    meta: {
        right: [],
    },
    children: [
        {
            path: '/StatisticsParkingList',
            component: StatisticsParkingList,
            name: '停车位统计',
            meta: {
                right: [],
                keepAlive: true,
            },
        },
        {
            path: '/PropertyParking',
            component: PropertyParking,
            name: '物业项目统计',
            meta: {
                right: [],
            },
        },
        {
            path: '/chargingStatistics',
            component: chargingStatistics,
            name: '物业项目统计',
            meta: {
                right: [],
            },
        },
        {
            path: '/DisputesParking',
            component: DisputesParking,
            name: '纠纷类型',
            meta: {
                right: [],
            },
        },
        {
          path: '/electricBicycleDetails',
          component: electricBicycleDetails,
          name: '电动自行车充换电设施情况',
          meta: {
              right: [],
          },
      },
    ]
};
export default StatisticsParkingRouter;